import { Injectable } from "@angular/core";
import { IktvaForm } from "../models/iktvaForm.model";

@Injectable({ providedIn:"root" })
export class DataMigrationService {
  public iktvaFormData: IktvaForm | null = null;
}
